<div class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col">
                <div class="page-title">
                    <h2>{{ 'subscription.billing_history' | translate }}</h2>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-9">
                <div class="billing-container">
                    <!-- Header -->
                    <header class="billing-header">
                        <p>{{ 'subscription.billing_description' | translate }}</p>
                    </header>

                    <!-- Loading State -->
                    <div *ngIf="loading" class="text-center py-5">
                        <div class="spinner-border text-success" role="status">
                            <span class="visually-hidden">{{ 'common.loading' | translate }}...</span>
                        </div>
                        <p class="mt-3 text-muted">{{ 'common.loading' | translate }}...</p>
                    </div>

                    <!-- Empty State -->
                    <div *ngIf="!loading && !hasSubscriptions" class="empty-state text-center py-5">
                        <i class="fa fa-receipt fa-3x text-muted mb-3"></i>
                        <h4>{{ 'subscription.no_billing_history' | translate }}</h4>
                        <p class="text-muted">{{ 'subscription.no_billing_description' | translate }}</p>
                        <a [routerLink]="['/user/subscription']" class="btn btn-success mt-3">
                            {{ 'subscription.view_plans' | translate }}
                        </a>
                    </div>

                    <!-- Billing Table -->
                    <div *ngIf="!loading && hasSubscriptions" class="billing-table-wrapper">
                        <div class="table-responsive">
                            <table class="table table-hover billing-table">
                                <thead>
                                    <tr>
                                        <th>{{ 'subscription.date' | translate }}</th>
                                        <th>{{ 'subscription.package' | translate }}</th>
                                        <th>{{ 'subscription.period' | translate }}</th>
                                        <th>{{ 'subscription.billing_period' | translate }}</th>
                                        <th>{{ 'subscription.amount' | translate }}</th>
                                        <th>{{ 'subscription.payment_method' | translate }}</th>
                                        <th>{{ 'subscription.status' | translate }}</th>
                                        <th>{{ 'subscription.tablet' | translate }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let sub of subscriptions">
                                        <td class="date-cell">
                                            <span class="date">{{ formatDate(sub.payment?.paymentDate) }}</span>
                                        </td>
                                        <td class="package-cell">
                                            <span class="package-badge">{{ sub.packageTitle }}</span>
                                        </td>
                                        <td class="period-cell">
                                            <span class="period">{{ formatDate(sub.startDate) }} - {{ formatDate(sub.endDate) }}</span>
                                        </td>
                                        <td class="billing-period-cell">
                                            <span class="billing-period">{{ sub.period || 'N/A' }}</span>
                                        </td>
                                        <td class="amount-cell">
                                            <span class="amount">{{ sub.amount?.toLocaleString() }} {{ sub.payment?.currency }}</span>
                                        </td>
                                        <td class="payment-method-cell">
                                            <span class="payment-method">{{ getPaymentMethodLabel(sub.payment?.paymentMethod) }}</span>
                                        </td>
                                        <td class="status-cell">
                                            <span class="badge" [ngClass]="getStatusBadgeClass(sub.status)">
                                                {{ sub.status }}
                                            </span>
                                        </td>
                                        <td class="tablet-cell">
                                            <span *ngIf="sub.tablet" class="tablet-badge">
                                                <i class="fa fa-check-circle text-success"></i> {{ 'common.yes' | translate }}
                                            </span>
                                            <span *ngIf="!sub.tablet" class="tablet-badge">
                                                <i class="fa fa-times-circle text-muted"></i> {{ 'common.no' | translate }}
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- Pagination -->
                        <div class="pagination-wrapper" *ngIf="totalPages > 1">
                            <nav aria-label="Page navigation">
                                <ul class="pagination justify-content-center">
                                    <li class="page-item" [class.disabled]="currentPage === 1">
                                        <a class="page-link" (click)="loadSubscriptions()" [routerLink]="[]">
                                            <i class="fa fa-chevron-left"></i>
                                        </a>
                                    </li>
                                    <li class="page-item active">
                                        <span class="page-link">{{ currentPage }} / {{ totalPages }}</span>
                                    </li>
                                    <li class="page-item" [class.disabled]="currentPage === totalPages">
                                        <a class="page-link" (click)="loadSubscriptions()" [routerLink]="[]">
                                            <i class="fa fa-chevron-right"></i>
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-3">
                <app-sidebar [currentUser]="user"></app-sidebar>
            </div>
        </div>
    </div>
</div>
